import { defineComponent as _defineComponent } from 'vue'
import { useGetAccountQuery } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'csrd',
  setup(__props) {

const { loading } = useGetAccountQuery({})

return { __sfc: true,loading }
}

})